import classNames from "classnames";
import ExcludeIcon from "assets/icons/ExcludeIcon";
import styles from "./styles.module.scss";
import { VisualSimilarityIcon } from "../../../../pages/DataPage/CardsView/DataPageFilters/SearchContainer/Icons";
import { Tooltip } from "antd";
import { useFeatureFlagService } from "hooks/useFeatureFlagService";
import { VQL_EXCLUDE } from "helpers/constants/filters";

interface ActionButtonsProps {
  showSimilarityButton: boolean;
  onSimilarityClick: (negation?: boolean) => void;
}

const ActionButtons = ({
  onSimilarityClick,
  showSimilarityButton,
}: ActionButtonsProps) => {
  const isVqlExcludeEnabled = useFeatureFlagService(VQL_EXCLUDE).enabled;
  return (
    <div className={styles.actionButtons}>
      {showSimilarityButton && (
        <>
          {isVqlExcludeEnabled && (
            <Tooltip title="Exclude Similar">
              <div
                onClick={() => onSimilarityClick(true)}
                className={classNames(
                  styles.actionButton,
                  styles.actionButtonExclude,
                  styles.noDetailsClick,
                )}
              >
                <ExcludeIcon />
              </div>
            </Tooltip>
          )}
          <Tooltip title="Find Similar">
            <div
              onClick={() => onSimilarityClick(false)}
              className={classNames(styles.actionButton, styles.noDetailsClick)}
            >
              <VisualSimilarityIcon />
            </div>
          </Tooltip>
        </>
      )}
    </div>
  );
};

export default ActionButtons;
